import { ENVIRONMENT, Environment, getEnvironmentName } from 'utils/environment';
import { SentryServiceInterface } from 'utils/integrations/Sentry/types';
import { Nullable } from 'utils/types';
import SentryService, { MockyService } from 'utils/integrations/Sentry/Service';
import User from 'auth/User';

const EXCLUDED_ENVIRONMENTS = new Set<Environment>([ENVIRONMENT.LOCAL, ENVIRONMENT.E2E]);

let service: SentryServiceInterface;

export const isRunningAllowed = (env: Environment): boolean => {
  return Boolean(env && !EXCLUDED_ENVIRONMENTS.has(env));
};

export const createSentry = (user: Nullable<User>): SentryServiceInterface => {
  const env = getEnvironmentName();

  if (isRunningAllowed(env)) {
    service = new SentryService(env, user);
  } else {
    service = new MockyService();
  }

  return service;
};

export const getSentry = () => {
  return service;
};
